<template>
  <div v-if="$store.state.global.device.templates" id="templatesTab">
    <b-row>
      <b-col>
        <b-form-group>
          <search-input v-model="query" />
        </b-form-group>
      </b-col>
      <b-col>
        <b-col class="text-right">
          <b-button variant="outline-danger" @click="hideAll()">
            Hide All
          </b-button>
          <b-button variant="outline-success" class="ml-2" @click="unhideAll()">
            Unhide All
          </b-button>
          <b-button
            v-router-link="{
              name: 'template-editor',
              query: { device_id: $store.state.global.device.id },
            }"
            class="ml-2"
            variant="outline-primary"
          >
            <i class="fa fa-plus-circle" /> Add Template
          </b-button>
        </b-col>
      </b-col>
    </b-row>
    <div v-for="type in types" :key="type.id">
      <h3>{{ type.label }}</h3>
      <b-card-group columns class="ml-5">
        <b-card
          v-for="template in displayDeviceTemplates.filter((template) => {
            return (
              template[type.key] == 1 &&
              template.easyinstall == type.easyinstall
            );
          })"
          :key="template.id"
          v-router-link="{ name: 'template-detail', params: template }"
          no-body
        >
          <img
            :src="'https://cdn.gokaizen.com/' + template.svg"
            alt=""
            style="max-width:100%;"
          />
          <b-card-body>
            <h4>{{ template.name }}</h4>
            <p>{{ template.hidden ? 'Hidden' : 'Unhidden' }}</p>
          </b-card-body>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>

<script>
import $api from '@/services/api';
import $search from '@/services/search';
import SearchInput from '@/components/SearchInput';

export default {
  name: 'DeviceTemplatesTab',

  components: {
    SearchInput,
  },

  data() {
    return {
      query: '',
      types: [
        { key: 'typenormal', label: 'Normal Standard', easyinstall: 0 },
        { key: 'typenormal', label: 'Normal Easy', easyinstall: 1 },
        { key: 'typemagic', label: 'Magic Standard', easyinstall: 0 },
        { key: 'typemagic', label: 'Magic Easy', easyinstall: 1 },
        { key: 'typeair', label: 'Air Standard', easyinstall: 0 },
        { key: 'typeair', label: 'Air Easy', easyinstall: 1 },
        { key: 'typebody', label: 'Body Standard', easyinstall: 0 },
        { key: 'typebody', label: 'Body Easy', easyinstall: 1 },
      ],
    };
  },

  computed: {
    displayDeviceTemplates() {
      return $search(this.$store.state.global.device.templates, this.query);
    },
  },

  methods: {
    hideAll() {
      const { templates } = this.$store.state.global.device;
      Promise.all(
        templates.map((template) => {
          template.hidden = true;
          return $api.put(`/v1/internal/templates/${template.id}`, template);
        }),
      );
    },
    unhideAll() {
      const { templates } = this.$store.state.global.device;
      Promise.all(
        templates.map((template) => {
          template.hidden = false;
          return $api.put(`/v1/internal/templates/${template.id}`, template);
        }),
      );
    },
  },
};
</script>
